import { Button } from 'antd'
import { FC } from 'react'
import { QueryTenantsResponse } from '@/api/tenants/response.types.ts'
import { RowNode } from '@/presentation/common/components/dataGrid/lib/api.types.ts'
import { useCrud } from '@/presentation/common/hooks/crud/useCrud.ts'
import { useMaintainerStore } from '@/presentation/common/store/zustand/maintainer.ts'
import { DeleteTenantsFormProps } from '@/presentation/tenants/forms/types.ts'
import { useDeleteTenants } from '@/presentation/tenants/hooks/useDeleteTenants.ts'

export const DeleteTenantsForm: FC<DeleteTenantsFormProps> = ({ onCancel, onFinish }) => {
  const messageApiKey = 'DeleteTenantForm-alert'
  const { submit, isSuccess, isLoading, isError, message } = useDeleteTenants()
  useCrud({ messageApiKey, message, isSuccess, isLoading, isError })

  const selectionNodes = useMaintainerStore((state) => state.selectionV2)
  const ids: QueryTenantsResponse['items'][0]['id'][] = selectionNodes.map((node: RowNode<QueryTenantsResponse['items'][0]>) => node.data.id)

  const onConfirmDelete = async () => {
    if (isLoading) {
      return
    }

    await submit({ ids })
    onFinish?.call(this)
  }

  return (
    <>
      <p className="text-center mb-6">
                Está apunto de eliminar los inquilinos seleccionados ({ids.length}).<br/>
                ¿Desea continuar con esta operación?
      </p>
      <div className="flex justify-center gap-2.5 pb-2">
        <Button size="small" type="primary" onClick={onCancel}>Cancelar</Button>
        <Button size="small" type="primary" danger onClick={onConfirmDelete}
          disabled={isLoading}>Eliminar</Button>
      </div>
    </>
  )
}
